import getDestinationIcon from "helpers/destinations/getDestinationIcon";
import getSourceIcon from "helpers/Sources/getSourceIcon";

export const HOME_MOBILE_TRACKERS_PREVIEW_COUNT = 3;

export const textCharacterLimit = (text, limit = 1500) => {
    const value = text?.toString?.() ?? "";
    return value.length > limit ? `${value.substring(0, limit)}...` : value;
};

export const getReportPath = (item) => {
    if (item?.link) {
        try {
            const url = new URL(item.link);
            return `${url.pathname}${url.search}`;
        } catch {
            return item.link;
        }
    }
    return `/tracker-reports/${item.tracker_id}?open_documents=1`;
};

export const getTrackerNameById = (trackers, trackerId) =>
    trackers?.find((item) => item.id === trackerId)?.name ?? null;

export const getVisibleMobileTrackers = (
    trackers,
    showAll,
    previewCount = HOME_MOBILE_TRACKERS_PREVIEW_COUNT,
) => {
    const remainingCount = Math.max(0, (trackers?.length ?? 0) - previewCount);
    const visibleTrackers =
        showAll || remainingCount === 0 || !trackers
            ? trackers
            : trackers.slice(0, previewCount);

    return { remainingCount, visibleTrackers };
};

export const getDashboardSourceIcon = (sources, sourceTypeId) =>
    getSourceIcon(sources, sourceTypeId);

export const getDashboardDestinationIcon = (
    destinations,
    destinationTypeId,
) => {
    const destination = destinations?.find(
        (item) => item.destination_type_id === destinationTypeId,
    );

    return getDestinationIcon(destination?.destination_type?.code);
};
